import { UserInfoContext } from "Context/CommonContext";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import FacultiesRegionsFilter from "Pages/FacultiesAntd/Regions/FacultiesRegionsFilter";
import { Badge, Button, Space, Tag } from "antd";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
interface FacultiesRegionsHeaderIF {
  filterState: any;
  setFilterState: any;
  applyFilter: any;
  open: boolean;
  setOpen: any;
  dates: any;
  setDates: any;
}
const FacultiesRegionsHeader = ({
  filterState,
  setFilterState,
  applyFilter,
  open,
  setOpen,
  dates,
  setDates,
}: FacultiesRegionsHeaderIF) => {
  const navigate = useNavigate();
  const { setFacultyPerformance } = useContext(FacultyPerformanceContext);
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const { screen }: any = useWindowSize();
  const backButtonHandler = () => {
    navigate("/admin/dashboard", {
      replace: true,
      state: {
        selectedStudent: null,
      },
    });
  };
  const userInfo = useContext<any>(UserInfoContext);
  const newFilterState = JSON.parse(JSON.stringify(filterState));
  const chipsFields = newFilterState && newFilterState.chipFields;
  delete newFilterState["chipFields"];
  const filterLength = Object.values(newFilterState).length;
  const resetHandler = () => {
    const currentMonth = dayjs().startOf("month");
    const nextMonth = dayjs().endOf("month");
    const dates = [currentMonth, nextMonth];
    const obj = {
      streamIds:
        userInfo?.userStreams && userInfo?.userStreams[0] != undefined
          ? userInfo?.userStreams[0]
          : null,
      yearMonth: dates,
      chipFields: {
        streamIds:
          userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        yearMonth: dates,
      },
    };
    setIsFilterApplied(false);
    setDates(dates);
    setFilterState(obj);
    applyFilter(obj);
  };
  const returnDate = (date: any) => {
    return date?.[0].format("MMM-YYYY") + " ~ " + date?.[1].format("MMM-YYYY");
  };
  const Reset = () => <Button onClick={resetHandler}>Reset</Button>;
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-start">
              <Button
                type="primary"
                onClick={() => {
                  setIsFilterApplied(true);
                  setFacultyPerformance(filterState);
                  applyFilter(filterState);
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              {isFilterApplied ? <Reset /> : null}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <FacultiesRegionsFilter
          setFilterState={setFilterState}
          filterState={filterState}
          dates={dates}
          setDates={setDates}
        />
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={"My Regions"}
        backButtonHandler={backButtonHandler}
      >
        <Space>
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <>
              {Object.keys(filterState.chipFields).map((ele: any) => {
                return (
                  <Tag
                    style={{
                      textAlign: "center",
                      textTransform: "capitalize",
                    }}
                    key={ele}
                  >
                    {typeof chipsFields[ele] != "object"
                      ? chipsFields[ele]
                      : ele === "yearMonth"
                      ? returnDate(filterState[ele])
                      : filterState[ele]["label"]}
                  </Tag>
                );
              })}
            </>
          )}
          <Badge count={filterLength ? filterLength : 0}>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Filters
            </Button>
          </Badge>
          {isFilterApplied ? <Reset /> : null}
        </Space>
      </HeadersComponent>
    </>
  );
};

export default FacultiesRegionsHeader;
